import { UserMenu, Logout } from 'react-admin'


export const CustomUserMenu = () => {
   return (
     <UserMenu>
        <Logout/>
     </UserMenu>
   )
}